import React, { useEffect, useState } from "react";
import { Form, Input, Button, notification, Tooltip } from "antd";
import "./ForgetVerifiction.css";
import Index from "../Index";
import VerificationInput from "react-verification-input";
import { useDispatch, useSelector } from "react-redux";
import { ForgetVerificationActionHandler } from "../../Redux/Actions/common/ForgetPassword";
import { useNavigate } from "react-router-dom";
import { MdInfoOutline } from "react-icons/md";

const ForgetVerifiction = () => {
  const mainLogo = "/assets/QA_Logo.svg";
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  const [verificationValue, setVerificationValue] = useState("");
  const [api, contextHolder] = notification.useNotification();
  const forgetverificationdata = useSelector(
    (state) => state?.ForgetPasswordData
  );
  // const openNotificationWithIcon = (type) => {
  //   api[type]({
  //     message: forgetverificationdata?.forget_varification_data?.message,
  //   });
  // };
  const handleVerificationChange = (value) => {
    setVerificationValue(value);
  };

  useEffect(() => {
    if (forgetverificationdata?.forget_varification_data) {
      // openNotificationWithIcon("success");
      setTimeout(() => {
        Navigate("/login");
      }, [2000]);
    }
    // eslint-disable-next-line
  }, [forgetverificationdata]);
  const onFinish = (value) => {
    let data = {
      username: value?.email,
      code: verificationValue,
      password: value?.password,
    };
    dispatch(ForgetVerificationActionHandler(data));
  };

  const tooltipContent = (
    <div className="remove-tooltip-space">
      <p>1. Your password must be 8 to 50 characters long.</p>
      <p>2. It must include at least one uppercase letter.</p>
      <p>3. It must include at least one lowercase letter.</p>
      <p>4. It must include at least one number.</p>
      <p>5. It must include at least one special character.</p>
      <p>6. It must not be the same as your user login ID.</p>
    </div>
  );
  return (
    <>
      <div className="verification-container">
        <Index />
        {contextHolder}
        <div className="verification-main">
          <div className="verification-div">
            <div className="center-img">
              <img src={mainLogo} alt="" className="centered-image" />
            </div>

            <p className="verification_text">Verification</p>
            <p className="verification_midtext">
              Check your email for the code and enter it here. You can edit your
              email if it's incorrect.
            </p>
            <Form
              className="forget-verification"
              name="verification"
              initialValues={{
                email: "",
                code: "",
                password: "",
              }}
              onFinish={onFinish}
            >
              <label>Your email</label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <div className="passoord-tooltip">
                Enter new password
                <Tooltip
                  placement="top"
                  title={tooltipContent}
                  overlayStyle={{ maxWidth: "900px" }}
                >
                  <MdInfoOutline />
                </Tooltip>
              </div>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your new password!",
                  },
                ]}
              >
                <Input.Password placeholder=" Enter your new password" />
              </Form.Item>
              <div className="Verification_input">
                <VerificationInput
                  validChars="0-9"
                  value={verificationValue}
                  placeholder=""
                  onChange={handleVerificationChange}
                />
              </div>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="forget-verification-button submit_login-btn"
                >
                  Next
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetVerifiction;
